import { isString } from 'lodash'

const splitPrice = (price = '') => {
  const fixedPrice = isString(price) ? price : price + ''
  let resultArr = ['0', '00']
  if (fixedPrice.includes('.')) {
    resultArr = fixedPrice.toString().split('.')
  } else {
    resultArr[0] = fixedPrice
  }
  return {
    unit: '￥',
    integer: resultArr[0] || 0,
    decimals: resultArr[1],
  }
}

export default splitPrice